import styled, { keyframes } from "styled-components";
import { paletas } from "../../../styles/theme";

const AnimaBGTriangulo = keyframes`
 from {
  transform: scale(0) rotate(0deg);
 }
 0.5% {
  transform: scale(1) rotate(0deg);
 }
 to {
  transform: scale(1) rotate(360deg);  
 }
`;

const AnimaTela = keyframes`
 from {
  left: -100%;
  opacity: 0;
 }
 to {
  left: 0%;
  opacity: 1;
 }
`;

const animaErro = keyframes`
  from {
    margin-right: -10px;
  }
  25% {
    margin-right: -25px;
  }
  50% {
    margin-right: -5px;
  }
  75% {
    margin-right: -15px;
  }
  to {
    margin-right: 0px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
  height: 100vh;
  margin: 0 40px;

  a {
    color: ${paletas.White};
    margin: 3px 0;
    text-transform: uppercase;
  }

  form {
    width: 100%;
    max-width: 600px;
    margin: 0 10px;
    position: relative;
    transition: all 0.25s;
    animation: 0.3s ${AnimaTela} ease-in-out;
  }

  h2 {
    text-align: center;
  }

  input {
    width: 100%;
    margin: 10px 0;
    padding: 10px;
    border: none;
    border-radius: 0.25rem;
    transition: all 0.25rem;
  }

  span {
    color: ${paletas.RedLight};
  }

  .input-submit {
    font-family: "Big Shoulders Stencil Text", Arial, Helvetica, sans-serif;
    background-color: ${paletas.DarkOrange};
    color: ${paletas.Grafite};
    font-weight: bold;
    font-size: 18px;
    border: 1px solid ${paletas.Grafite};
    border-radius: 0.25rem;
    padding: 10px 0;
    cursor: pointer;
    transition: all 0.25s;
    text-transform: uppercase;

    &:hover {
      color: ${paletas.DarkOrange};
      background: ${paletas.Grafite};
      border: 1px solid ${paletas.DarkOrange};
    }
  }
`;

export const BgQuadrado = styled.div`
  position: absolute;
  width: 200px;
  height: 200px;
  left: -30px;
  top: -30px;
  transition: all 2s;
  clip-path: polygon(
    0% 0%,
    0% 100%,
    25% 100%,
    25% 25%,
    75% 25%,
    75% 75%,
    25% 75%,
    25% 100%,
    100% 100%,
    100% 0%
  );
  background: rgba(0, 0, 0, 0.2);
  z-index: -1;
  animation: 60s ${AnimaBGTriangulo} infinite linear;

  @media (min-width: 400px) {
    top: -40px;
    width: 300px;
    height: 300px;
  }

  @media (min-width: 700px) {
    width: 400px;
    height: 400px;
  }
`;

export const MensagemAtencao = styled.div`
  text-align: center;
  margin-bottom: 20px;

  p {
    margin: 10px 0;
  }
`;

export const Erro = styled.div`
  display: flex;
  justify-content: center;

  span {
    font-size: 14px;
    position: relative;
    width: 100%;
    display: block;
    transition: all 0.25s;
    animation: 0.5s ${animaErro} ease;
  }
`;
